<template>
  <span ref="numberEl" class="animate-number"></span>
</template>

<script setup>
import { animate, onScroll } from 'animejs';
import { ref, onMounted } from 'vue';

const props = defineProps(['target', 'duration']);

const numberEl = ref(null);

onMounted(() => {
  const el = numberEl.value;
  const count = +props.target;
  const duration = +props.duration || 2000;

  const data = { count: 0 };

  animate(data, {
    count,
    duration,
    ease: 'easeOutExpo',
    autoplay: onScroll({
      target: el,
      once: true,
    }),
    onUpdate: () => {
      el.textContent = Math.round(data.count).toLocaleString('en-US');
    },
    onComplete: () => {
      el.textContent = count.toLocaleString('en-US');
    }
  });
});
</script>